import './BterAILoader.css';

function BterAILoader() {
  return (
    <div id="bterai-loader">
      <div className="bterai-dot-loader"></div>
      <div className="bterai-dot-loader bterai-dot-loader--2"></div>
      <div className="bterai-dot-loader bterai-dot-loader--3"></div>
    </div>
  );
}

export default BterAILoader;

type IProps = {
  children: React.ReactNode;
};

export const BterAILoaderWrapper = ({ children }: IProps) => {
  return <div className="full-height">{children}</div>;
};
